import React, { ReactNode } from 'react';

import { LightTipIcon } from '../Icons';

import styles from './style/Alert.module.scss';

interface AlertProps {
  children: ReactNode;
}

export default function Alert({ children }: AlertProps) {
  return (
    <div className={styles.alert}>
      <div className={styles.alert__content}>
        <div className={styles.alert__icon}>
          <LightTipIcon />
        </div>
        <p className={styles.alert__text}>{children}</p>
      </div>
    </div>
  );
}
